import React from 'react'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import BillFeeUI from '../../../components/superUser/loan/BillFeeUI'
import ProcessingFeeSF from '../../../components/superUser/loan/ProcessingFeeSF'
import ApplicationFeeSF from '../../../components/superUser/loan/ApplicationFeeSF'
import PrepaymentFeeUI from '../../../components/superUser/loan/PrepaymentFeeUI.js'
import OutOfPocketExpenseSF from '../../../components/superUser/loan/OutOfPocketExpenseSF.js'
import AddChargeAmountModalSF from './AddChargeAmountModalSF.js'
import AddChargeAmountUpdateModalSF from './AddChargeAmountUpdateModalSF.js'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF.js'

const LoanFeePageUI = ({ context, errorList, loan, outOfPocketExpenses, grandTotals, onRefreshClick,
  prepaymentFeeWaived, onWaivePrepaymentFeeSubmitClick, onWaivePrepaymentFeeCancelClick,
  billProcessingFeeSubmitted, onBillProcessingFeeSubmitClick, onBillProcessingFeeCancelClick,
  legalFeeSubmitted, onLegalFeeSubmitClick, onLegalFeeCancelClick,
  pFStatusUpdated, onPFStatusUpdateClick, onPFStatusCancelClick,
  pF2StatusUpdated, onPF2StatusUpdateClick, onPF2StatusCancelClick,
  onProcFeeClick, procFeeMode, onProcFeeCancel,
  onUploadTDSClick1, onUploadTDSClick2, uploadTDSErrorList1, uploadTDSMode1, onUploadTDSCancelClick, onUploadTDSUpload1,
  uploadTDSErrorList2, uploadTDSMode2, onUploadTDSUpload2, onDownloadClick1, onDownloadClick2,
  addMode, onAddChargesClick, onCancelAddCharges, onDocsUpload,
  legalInvoiceUpdateMode, onLegalInvoiceUpdateClick, onLegalInvoiceUpdateCancel, dateCreated, selectedCharge, alreadyPaid, invoiceNumber,
  uploadMode, onUploadClick, onUploadCancelClick, onFileUpload
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_loan_a_lst'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='fees'
  >
    {
      (!loan || !outOfPocketExpenses || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Fees</b></span>
            </span>
          }
          right={<span />}
        />
        <ApplicationFeeSF
          context={context} loan={loan}
          onRefreshClick={onRefreshClick}
        />
        <ProcessingFeeSF
          context={context} loan={loan}
          onRefreshClick={onRefreshClick}
          pFStatusUpdated={pFStatusUpdated}
          onPFStatusUpdateClick={onPFStatusUpdateClick}
          onPFStatusCancelClick={onPFStatusCancelClick}
          pF2StatusUpdated={pF2StatusUpdated}
          onPF2StatusUpdateClick={onPF2StatusUpdateClick}
          onPF2StatusCancelClick={onPF2StatusCancelClick}
          onProcFeeClick={onProcFeeClick}
          procFeeMode={procFeeMode}
          onProcFeeCancel={onProcFeeCancel}
          onUploadTDSClick1={onUploadTDSClick1}
          onUploadTDSClick2={onUploadTDSClick2}
          onUploadTDSCancelClick={onUploadTDSCancelClick}
          uploadTDSErrorList1={uploadTDSErrorList1}
          uploadTDSMode1={uploadTDSMode1}
          onUploadTDSUpload1={onUploadTDSUpload1}
          uploadTDSErrorList2={uploadTDSErrorList2}
          uploadTDSMode2={uploadTDSMode2}
          onUploadTDSUpload2={onUploadTDSUpload2}
          onDownloadClick1={onDownloadClick1}
          onDownloadClick2={onDownloadClick2}
        />
        <PrepaymentFeeUI
          context={context} loan={loan}
          onRefreshClick={onRefreshClick}
          prepaymentFeeWaived={prepaymentFeeWaived}
          onWaivePrepaymentFeeSubmitClick={onWaivePrepaymentFeeSubmitClick}
          onWaivePrepaymentFeeCancelClick={onWaivePrepaymentFeeCancelClick}
        />
        <BillFeeUI
          context={context} loan={loan}
          onRefreshClick={onRefreshClick}
          onBillProcessingFeeSubmitClick={onBillProcessingFeeSubmitClick}
          onBillProcessingFeeCancelClick={onBillProcessingFeeCancelClick}
          billProcessingFeeSubmitted={billProcessingFeeSubmitted}
          legalFeeSubmitted={legalFeeSubmitted}
          onLegalFeeSubmitClick={onLegalFeeSubmitClick}
          onLegalFeeCancelClick={onLegalFeeCancelClick}
        />
        <OutOfPocketExpenseSF
          context={context}
          title="OOP Expense"
          chargeType="oop_expense"
          loan={loan}
          outOfPocketExpenses={outOfPocketExpenses.filter(charge => charge.chargeType === 'oop_expense')}
          grandTotals={grandTotals}
          onAddChargesClick={onAddChargesClick}
          onLegalInvoiceUpdateClick={onLegalInvoiceUpdateClick}
          onUploadClick={onUploadClick}
          onUploadCancelClick={onUploadCancelClick}
          onRefreshClick={onRefreshClick}
        />
        <OutOfPocketExpenseSF
          context={context}
          title="Interest on Overdue OOP Expense"
          chargeType="interest_on_overdue_oop_exp"
          loan={loan}
          outOfPocketExpenses={outOfPocketExpenses.filter(charge => charge.chargeType === 'interest_on_overdue_oop_exp')}
          grandTotals={grandTotals}
          onAddChargesClick={onAddChargesClick}
          onUploadClick={onUploadClick}
          onLegalInvoiceUpdateClick={onLegalInvoiceUpdateClick}
          onRefreshClick={onRefreshClick}
        />
      </div>
    }

    <AddChargeAmountModalSF
      context={context}
      loan={loan}
      addMode={addMode}
      onCancelClick={onCancelAddCharges}
      signedUrlApi={`/api/su/loans/${loan && loan.loanId}/legalChargeInvoice/fileUploadSignedUrl`}
      onUpload={onDocsUpload}
    />
    <AddChargeAmountUpdateModalSF
      context={context}
      loan={loan}
      addMode={legalInvoiceUpdateMode}
      onCancelClick={onLegalInvoiceUpdateCancel}
      onRefreshClick={onRefreshClick}
      dateCreated={dateCreated}
      selectedCharge={selectedCharge}
      invoiceNumber={invoiceNumber}
      onUpload={onDocsUpload}
      alreadyPaid={alreadyPaid}
    />
    <FileUploadModalSF
      context={context}
      uploadMode={uploadMode}
      onCancelClick={onUploadCancelClick}
      signedUrlApi={`/api/su/loans/${loan && loan.loanId}/legalChargeInvoice/fileUploadSignedUrl`}
      onUpload={onFileUpload}
    />
  </SuperUserLoanPageSF>

export default LoanFeePageUI
